export type ApiError = Error & {
  status?: number
  data?: unknown
}

const getCsrfToken = (): string | null => {
  const meta = document.querySelector<HTMLMetaElement>("meta[name='csrf-token']")
  return meta?.getAttribute("content") ?? null
}

export const apiRequest = async <T = unknown>(
  path: string,
  options: RequestInit = {}
): Promise<T> => {
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
    ...(options.headers as Record<string, string> | undefined),
  }
  const token = getCsrfToken()
  if (token) headers["X-CSRF-Token"] = token

  let response: Response
  try {
    response = await fetch(path, {
      credentials: "same-origin",
      ...options,
      headers,
    })
  } catch (err) {
    throw err
  }

  let data: unknown = null
  try {
    data = await response.json()
  } catch {
    data = null
  }

  if (!response.ok) {
    const errorPayload = data as { error?: string; errors?: string[] } | null
    const errorMessage =
      errorPayload?.error ||
      (Array.isArray(errorPayload?.errors) ? errorPayload.errors.join(", ") : null) ||
      "Request failed"
    const err = new Error(errorMessage) as ApiError
    err.status = response.status
    err.data = data
    throw err
  }

  return data as T
}

export { getCsrfToken }
